// Export libraries load on first download to keep the main bundle small.

const slug = (title: string) => title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "canvas";

async function snapshot(node: HTMLElement): Promise<HTMLCanvasElement> {
  const html2canvas = (await import("html2canvas")).default;
  const background = getComputedStyle(node).backgroundColor || "#ffffff";
  return html2canvas(node, { scale: 2, backgroundColor: background, useCORS: true, logging: false });
}

export async function downloadPng(node: HTMLElement, title: string) {
  const canvas = await snapshot(node);
  const link = document.createElement("a");
  link.download = `${slug(title)}.png`;
  link.href = canvas.toDataURL("image/png");
  link.click();
}

/** A4 portrait PDF; tall canvases continue across pages. */
export async function downloadPdf(node: HTMLElement, title: string) {
  const [canvas, { jsPDF }] = await Promise.all([snapshot(node), import("jspdf")]);
  const dataUrl = canvas.toDataURL("image/png");

  const pdf = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
  const margin = 28;
  const pageWidth = pdf.internal.pageSize.getWidth() - margin * 2;
  const pageHeight = pdf.internal.pageSize.getHeight() - margin * 2;
  const imgHeight = (canvas.height * pageWidth) / canvas.width;

  let offset = 0;
  pdf.addImage(dataUrl, "PNG", margin, margin, pageWidth, imgHeight);
  while (imgHeight - offset > pageHeight) {
    offset += pageHeight;
    pdf.addPage();
    pdf.addImage(dataUrl, "PNG", margin, margin - offset, pageWidth, imgHeight);
  }
  pdf.save(`${slug(title)}.pdf`);
}
